import { gql } from "@apollo/client";

export const USER_POOL_GET_GIFT_CARD_BAG = gql`
  query UserPoolGetGiftCardBag {
    giftCardBag: getUsersBag {
      giftCards {
        id
        cardId
        offerId
        barCodeImageUrl
        barCodeType
        cardNumber
        cardPin
        isArchived
        archivedAt
        createdAt
        reloadHistory {
          amount {
            fiat {
              value
            }
          }
          totalSaleAmount
          btcVoucherDetails {
            btcVoucherUserAmount
          }
          giftDetails {
            name
            emailAddress
            message
          }
        }
        offer {
          id
          offerId
          brandName
          networkName
          barCodeType
          presetAmounts
          instruction {
            locale
            text
          }
          productDescription {
            locale
            text
          }
          termsAndConditions {
            inAppCard {
              locale
              text
            }
          }
          reloadSettings {
            isReloadable
          }
          commissionSettings {
            grossCommissionAmount
            memberRewardAmount
            isPercentage
          }
          styleSettings {
            includeImageBorder
            isCustomImageUpload
          }
          images {
            imageUrl
          }
        }
      }
    }
  }
`;
